import { Paper } from "@mui/material";
import blankProfile from "../component/schoolAdminPortal/images/blank-profile.png";
import moment from "moment";
const GameCard = ({ gameList, title, icon }) => {
  const dConvert = (d) => {
    var date = new Date(moment(d).format());
    date =
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "/" +
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      "/" +
      date.getFullYear();
    return date;
  };

  const tConvert = (time) => {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      time = time.slice(1);
      time[5] = +time[0] < 12 ? "AM" : "PM";
      time[0] = +time[0] % 12 || 12;
    }
    let timeformat = time.join("");
    if (timeformat.length == 10) {
      timeformat = timeformat.slice(0, 5) + " " + timeformat.slice(8, 10);
    } else {
      timeformat = timeformat.slice(0, 4) + " " + timeformat.slice(7, 9);
    }
    return timeformat;
  };
  return (
    <>
      <div className="d-flex-align-cent mg-bottom-10 gap-10">
        {icon}
        <p className="fs-20 semi-bold black disin noWrap">{title}</p>
      </div>
      {gameList?.map((item, index) => (
        <div key={index} className="col-11 col-sm-11 col-md-12 col-lg-12 pl-0 ">
          <div className="live-style-card mb-4 ">
            <div className="row m-0">
              <div className="col-md-12 col-lg-12 text-center pt-3">
                <div className="clear10"></div>
                <span className="fs-16 black regular">
                  {dConvert(item.eventDate)}
                  {",  "}
                  {tConvert(item.eventTime)}
                </span>
                <div>
                  <span className="fs-16 black regular">{item.location}</span>
                </div>
              </div>
              <div className="col-4 col-sm-5 col-md-5 text-center plr">
                <div className="clear20"></div>
                <div className="grey-box mx-auto">
                  <img
                    className="teamImg"
                    src={
                      item?.school1ProfilePhoto
                        ? item?.school1ProfilePhoto
                        : blankProfile
                    }
                    alt=""
                  ></img>
                </div>
                <div className="clear10"></div>
                <label className="fs-16 medium dblack">
                  {item?.school1Name}
                </label>
              </div>
              <div className="col-4 col-sm-2 col-md-2 p-0 text-center">
                <div className="clear20"></div>
                <label className="fs-28 bold"></label>
                <div className="clear10"></div>
                <label className="fs-18 regular pt-3 vs-label">VS</label>
              </div>
              <div className="col-4 col-sm-5 col-md-5 text-center plr">
                <div className="clear20"></div>
                <div className="grey-box mx-auto">
                  <img
                    className="teamImg"
                    src={
                      item.school2ProfilePhoto == null
                        ? blankProfile
                        : item.school2ProfilePhoto
                    }
                    alt=""
                  ></img>
                </div>
                <div className="clear10"></div>
                <label className="fs-16 medium dblack">
                  {item.school2Name}
                </label>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </div>
      ))}

      {gameList?.length === 0 && (
        <p className="nodatabox mg-bottom-20">
          <Paper className="activity-trending-container2  pd-10 mg-top-10">
            <p className="text-center">{`No ${title} Available.`}</p>
          </Paper>
        </p>
      )}
    </>
  );
};

export default GameCard;
